import type { ComponentSchema } from '../../../../../schema-types'

/** Shelf-label compare: up to 4 products side by side with price, price per kg / L / piece, discount and one row per attribute. */
export const schema: ComponentSchema = {
  type: 'compare',
  label: 'Compare',
  description: 'Up to four saved products side by side with the price per kg, litre or piece, the cheapest flagged, or an empty state.',
  supportedPages: ['compare'],
  variants: [{ id: 'v1', label: 'Side by side' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Compare products' },
    { key: 'emptyTitle', label: 'Empty title', type: 'string' },
    { key: 'emptyText', label: 'Empty message', type: 'string' },
  ],
}
